<div class="card border-0 shadow-sm">
	<div class="card-header bg-accent text-white">
		<strong>بحث عن حالة - عرض الصورة الممسوحة</strong>
	</div>
	<div class="card-body">
		<div class="row g-3 align-items-end">
			<div class="col-md-4">
				<label class="form-label">بحث (رقم وطني/رقم قيد)</label>
				<input class="form-control" [(ngModel)]="q" placeholder="أدخل رقم وطني أو رقم قيد">
			</div>
			<div class="col-md-3">
				<label class="form-label">من تاريخ</label>
				<input type="date" class="form-control" [(ngModel)]="fromDate">
			</div>
			<div class="col-md-3">
				<label class="form-label">إلى تاريخ</label>
				<input type="date" class="form-control" [(ngModel)]="toDate">
			</div>
			<div class="col-md-2">
				<button class="btn btn-primary w-100" (click)="search()">
					<i class="bi bi-search"></i> بحث
				</button>
			</div>
		</div>

		<div class="table-responsive mt-3">
			<table class="table table-striped table-bordered align-middle">
				<thead class="table-secondary">
					<tr>
						<th>رب الأسرة</th>
						<th>فرد الأسرة</th>
						<th>رقم القيد</th>
						<th>نوع الحالة</th>
						<th>تاريخ</th>
						<th>عرض الصورة</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let e of results">
						<td>{{e.headNationalId}}</td>
						<td>{{e.memberNationalId}}</td>
						<td>{{e.registryNumber}}</td>
						<td>{{e.caseType}}</td>
						<td>{{e.caseDate?.substring(0,10)}}</td>
						<td>
							<button class="btn btn-sm btn-outline-primary" (click)="viewImage(e)">
								<i class="bi bi-image"></i> عرض
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div *ngIf="imageUrl" class="mt-3 text-center">
			<img [src]="imageUrl" class="img-fluid rounded" alt="صورة الحالة" />
		</div>
		<div *ngIf="selected && !imageUrl" class="mt-3 text-center text-muted">
			لا توجد صورة محفوظة لهذه الحالة
		</div>
	</div>
</div>


